const modals = [
    {
        id: 'managerDoesntRemember',
        title: `Руководитель не помнит, уходит<br/>
        ли кто-то ещё из коллег в эти даты.<br/> 
        Придётся уточнить самостоятельно.`
    },
    {
        id: 'notActualGraph',
        title: `В графике отпусков неактуальная информация:<br/> 
        её заполняли для галочки в конце года, а потом<br/> 
        всё поменялось несколько раз.`
    },
    {
        id: 'runOverAll',
        title: `Оббегаете и обзваниваете всех коллег и узнаёте,<br/>
        что Антон запланировал отпуск в те же даты. Уйти<br/>
        одновременно вы не можете, что будете делать?`
    },
    {
        id: 'youAreLucky',
        title: `Вам везёт! Антон соглашается перенести отпуск<br/>
        на неделю. Всем бы таких отзывчивых коллег.`
    },
    {
        id: 'hrOneEye',
        title: `HR-специалист одним глазом смотрит<br/> 
        на ваше заявление и говорит,<br/> 
        что не хватает подписи руководителя.`
    },
    {
        id: 'bossIsAway',
        title: `Руководитель уехал в командировку,<br/>
        вернётся в пятницу. Кто же подпишет<br/>
        ваше заявление на отпуск?`
    },
    {
        id: 'foundAnotherManager',
        title: `Фух, заместителя на период командировки нашли.<br/>
        Осталось переписать заявление на его имя.`
    },
    {
        id: 'hrFoundFault',
        title: `HR-специалист сообщает, что вы неправильно<br/>
        написали название компании и нужно<br/>
        переписать заявление.`,
    },
    {
        id: 'unpaidLeave',
        title: `HR-специалист принимает заявление. Но звонит через<br/>
        полчаса и сообщает, что у вас в этом году осталось только<br/>
        два дня отпуска. Вы вспоминаете, что брали несколько<br/>
        дней между майскими. Теперь нужно согласовать<br/>
        с руководителем дополнительный неоплачиваемый отпуск.`
    },
    {
        id: 'unpaidLeaveIsOk',
        title: `Руководитель не против, чтобы вы взяли<br/>
        отпуск за свой счёт. Осталось теперь<br/>
        всё переоформить.`
    },
    {
        id: 'youAreTired',
        title: `Упс, кажется, вы утомились — отправили<br/>
        прошлый вариант заявления, и в HR-отделе<br/>
        отправили переписывать.`
    },
    {
        id: 'datesDoNotOverlap',
        title: `Руководитель не против, чтобы вы отдохнули,<br/>
        ведь ваши даты не пересекаются с отпусками коллег.`
    },
    {
        id: 'bitterExperience',
        title: `Наученные горьким опытом, вы переписываете<br/>
        заявление на имя заместителя, проверяете<br/>
        все даты и точки и подписываете у него.<br/>
        Остаётся только отправить в HR.`
    },
    {
        id: 'everythingIsOk',
        title: `Кажется, пока всё хорошо.<br/>
        Что дальше?`
    },
    {
        id: 'managerSendYouOff',
        title: `Руководитель решает: «Ну раз Антон написал заявление первым, пусть он и идёт. Ну или договоритесь как-нибудь сами».`
    }
]

export default modals